var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMxIconDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.875 2.25V0.375C4.875 0.167893 5.04289 0 5.25 0H11.25C11.4571 0 11.625 0.167893 11.625 0.375V2.25H14.25H16.875C17.0821 2.25 17.25 2.41789 17.25 2.625C17.25 2.83211 17.0821 3 16.875 3H14.625V17.625C14.625 17.8321 14.4571 18 14.25 18H2.25C2.04289 18 1.875 17.8321 1.875 17.625V3H0.375C0.167893 3 0 2.83211 0 2.625C0 2.41789 0.167893 2.25 0.375 2.25H2.25H4.875ZM5.25209 3C5.25139 3 5.25069 3.00001 5.24999 3.00001H2.62499V17.25H13.875V3.00001H11.25C11.2493 3.00001 11.2486 3 11.2479 3H5.25209ZM10.875 2.25H5.62499V0.750006H10.875V2.25ZM4.875 5.25C4.875 5.04289 5.04289 4.875 5.25 4.875C5.4571 4.875 5.625 5.04289 5.625 5.25V14.25C5.625 14.4571 5.4571 14.625 5.25 14.625C5.04289 14.625 4.875 14.4571 4.875 14.25V5.25ZM8.25 4.875C8.0429 4.875 7.875 5.04289 7.875 5.25V14.25C7.875 14.4571 8.0429 14.625 8.25 14.625C8.45711 14.625 8.625 14.4571 8.625 14.25V5.25C8.625 5.04289 8.45711 4.875 8.25 4.875ZM10.875 5.25C10.875 5.04289 11.0429 4.875 11.25 4.875C11.4571 4.875 11.625 5.04289 11.625 5.25V14.25C11.625 14.4571 11.4571 14.625 11.25 14.625C11.0429 14.625 10.875 14.4571 10.875 14.25V5.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMxIconDelete);
export default __webpack_public_path__ + "static/media/mxIconDelete.f393535a5fac278cd4bf5fca8bab3eb8.svg";
export { ForwardRef as ReactComponent };